import stringify from 'fast-safe-stringify';
import { LogActivity } from "../interfaces";
export var MessageEchoTreatment;
(function (MessageEchoTreatment) {
    MessageEchoTreatment["Ignore"] = "ignore";
    MessageEchoTreatment["Summarize"] = "summary";
    MessageEchoTreatment["Display"] = "display";
})(MessageEchoTreatment || (MessageEchoTreatment = {}));
const DebugHandlerDefaultOpts = {
    messageEcho: MessageEchoTreatment.Summarize,
};
export function buildDebugHandler(originator, opts) {
    if (typeof originator !== 'string' || !originator.length) {
        throw new Error('Debug handler requires name/originator for activity');
    }
    if (typeof opts === 'function') {
        return opts;
    }
    if (!opts || opts === false) {
        return false;
    }
    if (opts === true) {
        opts = {};
    }
    opts = Object.assign({}, DebugHandlerDefaultOpts, opts);
    const logger = opts.logger || console;
    const { minimal, messageEcho } = opts;
    return function (data) {
        const isSuppressedEcho = messageEcho !== MessageEchoTreatment.Display && _isReceivingPayloadEcho(data);
        if (isSuppressedEcho && messageEcho === MessageEchoTreatment.Ignore) {
            return;
        }
        const activity = data.activity || LogActivity.Misc;
        if (minimal && (activity !== LogActivity.ReportError && activity !== LogActivity.ReportWarning)) {
            return;
        }
        let msgParts = [
            `[${originator}] ${activity}: `
        ];
        data.message && msgParts.push(data.message);
        let shouldDisplayRawData = !data.skipPayload;
        if (isSuppressedEcho && messageEcho === MessageEchoTreatment.Summarize) {
            shouldDisplayRawData = false;
            msgParts.push(`Ignoring echo of received payload in endpoint "${data.endpointSenderId || '(not yet set)'}"`);
        }
        const err = data.error;
        delete data.error;
        shouldDisplayRawData && msgParts.push(_stringify(logger, data) || '{invalidData}');
        logger.log(msgParts.join(' '));
        if (err) {
            logger.error(err);
        }
    };
}
function _stringify(logger, data) {
    try {
        // @ts-ignore
        return stringify(data, null, 2);
    }
    catch (err) {
        logger.error('Default debugHandler encountered error stringifying data:', err);
    }
}
function _isReceivingPayloadEcho(data) {
    const { activity, endpointSenderId, payload } = data;
    return activity === LogActivity.TransportReceivingMessage &&
        endpointSenderId && payload &&
        payload.senderId === endpointSenderId;
}
//# sourceMappingURL=logging-support.js.map